import Vue from 'vue';
import { gsap } from 'gsap/all';

import debounce from 'lodash/debounce';
import Slides from '../classes/Slides';

Vue.component('slider-component', {
    props: {
        chapters: {
            required: true,
            type: Array
        }
    },

    data() {
        return {
            initTimeout: 0.5,
            slider: null,
            activeIndex: 0,
            grabbing: false,
            hidden: true,
            keyNavigationActive: false
        };
    },

    mounted() {
        const bounce = (value) => {
            if (value === this.activeIndex) {
                return;
            }
            const previousIndex = this.activeIndex;
            this.activeIndex = value;

            this.playTransition({
                currentIndex: value,
                previousIndex
            });
        }

        const debounceCalculate = debounce(bounce, 0, {
            'leading': false,
            'trailing': true
        });

        gsap.delayedCall(this.initTimeout, () => {
            this.slides = new Slides(this);
            this.slides.onActiveProjectIndexChange = debounceCalculate;
            this.slides.onDraggablePress = () => {
                this.grabbing = true;
            }

            this.slides.onDraggableRelease = () => {
                this.grabbing = false;
            }

            this.activeIndex = this.$root.lastVisitedChapter ?? 0;

            if (this.activeIndex !== 0 && this.$root.lastVisitedChapter) {
                this.slides.navigate(this.$root.lastVisitedChapter);
            }

            this.backgrounds = [...document.querySelectorAll('.image__holder')];
            if (this.backgrounds.length > 0) {
                this.backgrounds[this.activeIndex].classList.add('visible');

                const transitionEnd = () => {
                    this.backgrounds[this.activeIndex].children[0].style.transition = 'none';
                    this.backgrounds[this.activeIndex].removeEventListener('transitionend', transitionEnd);
                }

                this.backgrounds[0].addEventListener('transitionend', transitionEnd);
            }

            window.addEventListener('keydown', this.onKeyDown);
        });

        gsap.delayedCall(this.initTimeout + 1, () => {
            Vue.nextTick(() => {
                this.hidden = false;
            });
        });
    },

    methods: {
        animateNext(currentBackground, newBackground) {
            console.log('Animating Next');
            const duration = 1.4;
            const clipDuration = 1.4;
            const ease = 'power2.out';

            const onComplete = () => {
                currentBackground.classList.remove('visible');
                currentBackground.classList.remove('current');

                newBackground.classList.remove('next');
                newBackground.style.zIndex = '';
                newBackground.style.clip = '';
                this.keyNavigationActive = false;
                console.log('On Complete');
            }

            gsap.to('.next', {
                duration: clipDuration,
                clip: 'rect(0px 120vw 120vh 0px)',
                ease
            })

            gsap.to('.current img', {
                duration,
                x: '-10vw',
                ease
            })

            gsap.to('.next img', {
                duration,
                x: '0',
                ease,
                onComplete
            })
        },

        animatePrevious(currentBackground, newBackground) {
            console.log('Animating Previous');
            const duration = 1.4;
            const clipDuration = 1.4;
            const ease = 'power2.out';

            const onComplete = () => {
                currentBackground.classList.remove('visible');
                currentBackground.classList.remove('current');

                newBackground.classList.remove('previous');
                newBackground.style.zIndex = '';
                newBackground.style.clip = '';
                this.keyNavigationActive = false;
            }

            gsap.to('.previous', {
                duration: clipDuration,
                clip: 'rect(0px 120vw 120vh 0px)',
                ease
            })

            gsap.to('.current img', {
                duration,
                x: '10vw',
                ease
            })

            gsap.to('.previous img', {
                duration,
                x: '0',
                ease,
                onComplete
            })
        },

        playTransition({ currentIndex, previousIndex }) {
            // Clean up previous leftovers
            gsap.set('.background-holder .image__holder', { clip: '', zIndex: '' });

            // What needs to be played.
            let direction = (currentIndex > previousIndex) ? 'up' : 'down';
            if (this.keyNavigationActive) {
                direction = 'up';
            }

            if (direction === 'up') {
                const newBackground = this.backgrounds[currentIndex];
                newBackground.classList.add('next');
                newBackground.classList.add('visible');
                newBackground.style.zIndex = 1;

                const currentBackground = this.backgrounds[previousIndex];
                currentBackground.classList.add('current');

                this.animateNext(currentBackground, newBackground);
                return;
            }

            if (direction === 'down') {
                const newBackground = this.backgrounds[currentIndex];
                newBackground.classList.add('previous');
                newBackground.classList.add('visible');
                newBackground.style.zIndex = 1;

                const currentBackground = this.backgrounds[previousIndex];
                currentBackground.classList.add('current');

                this.animatePrevious(currentBackground, newBackground);
            }
        },

        setActiveIndex(index) {
            // this.activeIndex = index;
        },

        goToChapter() {
            this.$refs.cta.classList.add('--hide');
            this.$root.router.setTransition('chapter');
            page(this.chapters[this.activeIndex].url);
        },

        onKeyDown(event) {
            if (this.keyNavigationActive) {
                return;
            }

            switch (event.keyCode) {
                case 37:
                    this.slides.navigate(-1);
                    this.keyNavigationActive = true;
                    break;
                case 39:
                    this.slides.navigate(1);
                    this.keyNavigationActive = true;
                    break;
                case 13:
                    this.goToChapter();
                    break;
                default:
                    // Nothing.
                    break;
            }
        },

        onNumberClick(index) {
            // return;
            if (index === this.activeIndex) {
                return;
            }

            if (this.activeIndex === 0) {
                if (index > 2) {
                    this.slides.navigate(-1);
                    this.keyNavigationActive = true;
                    return;
                }

                this.slides.navigate(index);
                this.keyNavigationActive = true;
                return;
            }

            if (this.activeIndex === this.chapters.length - 1) {
                if (index === 0) {
                    this.slides.navigate(1);
                    return;
                }
            }

            if (index > this.activeIndex) {
                this.slides.navigate(index - this.activeIndex);
                this.keyNavigationActive = true;
                return;
            }

            if (index < this.activeIndex) {
                this.slides.navigate(index - this.activeIndex);
                this.keyNavigationActive = true;
            }
        },

        linkToChapter(index) {
            this.$root.lastVisitedChapter = index;
        }
    },

    beforeDestroy() {
        window.removeEventListener('keydown', this.onKeyDown);
        this.slides.draggable[0].kill();
        this.slides.killCarousel()
        this.slides = null;
    }
});